"use client";

import { useQuery } from "@tanstack/react-query";

async function fetchFollowingActivity(): Promise<Record<string, any[]>> {
  const res = await fetch("/api/markets/following-activity");
  if (!res.ok) return {};
  const data = await res.json();
  return data.marketsActivity || {};
}

export function useFollowingActivity(category: string) {
  return useQuery({
    queryKey: ["markets", "followingActivity"],
    queryFn: fetchFollowingActivity,
    staleTime: 60 * 1000, // 1 minute
    gcTime: 5 * 60 * 1000,
    enabled: category !== "for-you" && category !== "sports",
  });
}
